import { GridCellProps, GridPagerSettings, GridRowProps } from '@progress/kendo-react-grid'
import moment from 'moment'
import { JSXElementConstructor, ReactElement, cloneElement } from 'react'
import { getBaseURL } from '../../../GlobalComponents/URLs'
import {
    AggregateDescriptor,
    State,
    compileFilter,
    groupBy,
    normalizeFilters,
    normalizeGroups,
    orderBy,
} from '@progress/kendo-data-query'
import { setGroupIds } from '@progress/kendo-react-data-tools'
import { isPresent } from '@progress/kendo-react-layout'
import { count, limit } from '@progress/kendo-data-query/dist/npm/array.operators'
import { filter } from '@progress/kendo-data-query/dist/npm/transducers'
import { compose } from '@progress/kendo-data-query/dist/npm/funcs'

export function formatCurrency(number: number) {
    const result = number.toLocaleString('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
    return '$' + result
}

export function formatDate(date: Date): string {
    let formattedDate = moment.utc(date).format('MM/DD/YY')
    if (formattedDate === '01/01/01' || formattedDate === 'Invalid date') {
        formattedDate = ''
    }
    return formattedDate
}

export const openNewCustWindow = (props: GridCellProps) => {
    const baseURL = getBaseURL()
    const url = `${baseURL}masterclient/main.aspx?OpenDialog=CustMaint&CustAcct=${props.dataItem.CustomerAccountCode}`
    const windowFeatures = 'width=1280,height=800,resizable=yes,scrollbars=yes'
    const newWindow = window.open(url, '_blank', windowFeatures)
    if (newWindow) {
        newWindow.focus()
    }
}
export const openNewInvoiceWindow = (props: GridCellProps) => {
    const baseURL = getBaseURL()
    const url = `${baseURL}masterclient/main.aspx?OpenDialog=CustInquiryInvoice&InvoiceNo=${props.dataItem.InvoiceNo}&CustAcct=${props.dataItem.CustomerAccountCode}`
    const windowFeatures = 'width=1280,height=800,resizable=yes,scrollbars=yes'
    const newWindow = window.open(url, '_blank', windowFeatures)
    if (newWindow) {
        newWindow.focus()
    }
}

export const rowRender = (
    trElement: React.ReactElement<HTMLTableRowElement>,
    props: GridRowProps
) => {
    let trProps: any
    if (props.rowType === 'groupFooter') {
        trProps = { style: { textAlign: 'right' } }
    }

    return cloneElement(trElement, { ...trProps }, trElement.props.children)
}
export const cellShortDate = (cellProps: GridCellProps) => {
    if (cellProps.rowType != 'groupFooter' && cellProps.rowType === 'data' && cellProps.field) {
        const value = cellProps.dataItem[cellProps.field]
        return <td style={{ textAlign: 'center' }}>{value && formatDate(value)}</td>
    } else if (cellProps.rowType === 'groupFooter') {
        return <td></td>
    } else {
        return <></>
    }
}
export const cellAlignRight = (cellProps: GridCellProps) => {
    if (cellProps.rowType != 'groupFooter' && cellProps.rowType === 'data' && cellProps.field) {
        const value = cellProps.dataItem[cellProps.field]
        return <td style={{ textAlign: 'right' }}>{value}</td>
    } else if (cellProps.rowType === 'groupFooter') {
        return <td></td>
    } else {
        return <></>
    }
}
export const cellCurrency = (cellProps: GridCellProps) => {
    if (cellProps.rowType === 'data' && cellProps.field) {
        const value = cellProps.dataItem[cellProps.field]
        return <td style={{ textAlign: 'right' }}>{value ? formatCurrency(value) : '$0'}</td>
    } else if (cellProps.rowType === 'groupFooter') {
        return <td style={{ textAlign: 'right' }}></td>
    } else {
        return <></>
    }
}

export const cellAggregateCurrency = (cellProps: GridCellProps) => {
    if (cellProps.rowType === 'data' && cellProps.field) {
        const value = cellProps.dataItem[cellProps.field]
        return <td style={{ textAlign: 'right' }}>{value && formatCurrency(value)}</td>
    } else if (cellProps.rowType === 'groupFooter') {
        return (
            <td aria-colindex={cellProps.columnIndex} role={'gridcell'}>
                Total: {formatCurrency(cellProps.dataItem.aggregates?.AmountDue?.sum)}
            </td>
        )
    } else {
        return <></>
    }
}
export const cellRender = (
    tdElement: ReactElement<HTMLTableCellElement, string | JSXElementConstructor<any>> | null,
    cellProps: GridCellProps
) => {
    if (cellProps.rowType === 'groupFooter') {
        if (cellProps.field === 'AmountDue') {
            return (
                <td
                    aria-colindex={cellProps.columnIndex}
                    role={'gridcell'}
                    style={{ textAlign: 'right' }}
                >
                    Total: {formatCurrency(cellProps.dataItem.aggregates?.AmountDue?.sum)}
                </td>
            )
        } else {
            return <td></td>
        }
    } else if (cellProps.rowType === 'groupHeader') {
        const green = { backgroundColor: '#d9e1f2' }
        const trProps: any = { style: green }
        if (tdElement) {
            return cloneElement(tdElement, { ...trProps }, tdElement.props.children)
        }
    }
    return tdElement
}

export const cellCustwindow = (cellProps: GridCellProps) => {
    if (cellProps.rowType === 'data') {
        return (
            <td colSpan={1} className="" role="gridCell" aria-colindex={2} data-grid-col-index="1">
                <span
                    onClick={() => openNewCustWindow(cellProps)}
                    style={{ color: '#0062FF', cursor: 'pointer' }}
                >
                    {cellProps.dataItem.CustomerName}
                </span>
            </td>
        )
    } else if (cellProps.rowType === 'groupFooter') {
        return <td></td>
    } else {
        return <></>
    }
}

export const cellInvoiceWindow = (cellProps: GridCellProps) => {
    if (cellProps.rowType === 'data') {
        return (
            <td colSpan={1} className="" role="gridCell" aria-colindex={3} data-grid-col-index="2">
                <span
                    onClick={() => openNewInvoiceWindow(cellProps)}
                    style={{ color: '#0062FF', cursor: 'pointer' }}
                >
                    {cellProps.dataItem.InvoiceNo}
                </span>
            </td>
        )
    } else if (cellProps.rowType === 'groupFooter') {
        return <td></td>
    } else {
        return <></>
    }
}
export const processWithGroups = (
    data: any[],
    dataState: State,
    aggregates: AggregateDescriptor[]
) => {
    const groups = dataState.group
    if (groups) {
        groups.map((group) => (group.aggregates = aggregates))
    }
    dataState.group = groups
    const newDataState = customProcess(data, dataState)
    setGroupIds({ data: newDataState.data, group: dataState.group })

    return newDataState
}

export const processDataState = (data: any[], dataState: State) => {
    const newDataState = customProcess(data, dataState)
    setGroupIds({ data: newDataState.data, group: dataState.group })

    return newDataState
}
const aggregates: AggregateDescriptor[] = [{ field: 'AmountDue', aggregate: 'sum' }]
export const createAppState = (skip: number, take: number, data: any) => {
    let pagerSettings: GridPagerSettings = {
        buttonCount: 5,
        info: true,
        type: 'input',
        pageSizes: [5, 10, 20, 100, 1000],
        previousNext: true,
    }
    return {
        items: data.slice(skip, skip + take),
        total: data.length,
        skip: skip,
        pageSize: take,
        pageable: pagerSettings,
    }
}

export const sortData = (data: ARAgingGridInvoice[]) => {
    return data.sort((a, b) => {
        if (a.EntityName < b.EntityName) return -1
        if (a.EntityName > b.EntityName) return 1

        if (a.EntityName === b.EntityName) {
            if (b.DaysPastDue !== a.DaysPastDue) {
                return b.DaysPastDue - a.DaysPastDue
            }
            return b.AmountDue - a.AmountDue
        }
        return 0
    })
}

var customProcess = function (data: any[], state: State) {
    var skipCount = state.skip,
        takeCount = state.take,
        filterDescriptor = state.filter,
        sort = state.sort,
        group = state.group
    var sortDescriptors = normalizeGroups(group || []).concat(sort || [])
    if (sortDescriptors.length && state.sort) {
        data = orderBy(data, sortDescriptors)
    }
    var hasFilters = isPresent(filterDescriptor) && filter.length
    var hasGroups = isPresent(group) && group?.length
    if (!hasFilters && !hasGroups) {
        return {
            data: takeCount ? data.slice(skipCount, skipCount ? skipCount : 0 + takeCount) : data,
            total: data.length,
        }
    }
    var total = 0
    var transformers = []
    var predicate
    if (hasFilters) {
        if (filterDescriptor) {
            predicate = compileFilter(normalizeFilters(filterDescriptor))
            total = count(data, predicate)
            transformers.push(filter(predicate))
        }
    } else {
        total = data.length
    }

    if (transformers.length) {
        var transform = compose.apply(void 0, transformers)
        if (predicate) {
            var result = groupBy(data, group, transform, limit(data, predicate))
            //  : exec(transform(concat), [], data)
            result.sort((a, b) => b.aggregates.AmountDue.sum - a.aggregates.AmountDue.sum)
            return { data: result, total: total }
        }
    }
    const newData = groupBy(data, group)
    newData.sort((a, b) => b.aggregates.AmountDue.sum - a.aggregates.AmountDue.sum)
    return {
        data: newData,
        total: total,
    }
}
